import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { zodResolver } from "@hookform/resolvers/zod";
import { DefaultFormMultiAutocomplete } from "../../../../../../common/components/default_form_multi_autocomplete";
import { DefaultFormSelectInput } from "../../../../../../common/components/default_form_select_input";
import { FormRangeDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_range_picker_input";
import { ReportOrdemComprasForm, ReportOrdemComprasSchema } from "../../../schemas/OrdemCompras_lista/report_ordem_compras";
import { useEffect, useMemo } from "react";
import { OrdemCompraDropDown } from "../../../../../../common/domain/models/ordem_compra_dropdown";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { FornecedorDropDown } from "../../../../../../common/domain/models/fornecedor_dropdown";

/**
 * ReportOrdemComprasModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  ordemComprasDropdown: OrdemCompraDropDown[];
  centroCustosDropdown: CentroCustoDropDown[];
  fornecedoresDropdown: FornecedorDropDown[];
  onClose: () => void;
  onSubmit: (form: ReportOrdemComprasForm) => void;
};

export const ReportOrdemComprasModal = ({
  open,
  saving,
  loading,
  ordemComprasDropdown,
  centroCustosDropdown,
  fornecedoresDropdown,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<ReportOrdemComprasForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(ReportOrdemComprasSchema),
  });

  const statusOptions = useMemo(() => {
    return [
      {
        id: 1,
        label: 'Todas as ordens de serviço',
      },
      {
        id: 2,
        label: 'Entregue',
      },
      {
        id: 3,
        label: 'Pendente',
      },
      {
        id: 4,
        label: 'Cancelada',
      },
    ];
  }, [
  ]);

  useEffect(() => {
    if (open) {
      hookForm.reset({ status: 1 });
    }
  }, [
    open,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title="Ordem Compras"
      confirmButtonLabel="Gerar"
      confirmSavingButtonLabel="Gerando..."
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="w-full flex flex-col gap-4 py-4">
        <DefaultFormMultiAutocomplete
          name='ordemCompras'
          label='Ordem de Compra'
          options={ordemComprasDropdown}
          getOptionKey={x => x.idOrdemCompra}
          getOptionLabel={x => x.descricao}
          reactHookForm={hookForm}
        />

        <DefaultFormMultiAutocomplete
          name='centroCustos'
          label='Centro de Custos'
          options={centroCustosDropdown}
          getOptionKey={x => x.id}
          getOptionLabel={x => x.title}
          reactHookForm={hookForm}
        />

        <DefaultFormSelectInput
          name='status'
          label='Status'
          showSelectionLabel={false}
          options={statusOptions}
          reactHookForm={hookForm}
        />

        <DefaultFormMultiAutocomplete
          name='fornecedores'
          label='Fornecedor'
          options={fornecedoresDropdown}
          getOptionKey={x => x.idFornecedor}
          getOptionLabel={x => x.nomeFantasia}
          reactHookForm={hookForm}
        />

        <FormRangeDatePickerInput
          name='data'
          label='Data'
          reactHookForm={hookForm}
        />
      </div>
    </BaseFormControlledModal>
  );
}